/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { getSortedList } from 'src/utils/global';
import { BaseAction } from '../../types/base-action.type';
import * as actions from 'src/types/settings-action.type';

interface SettingsType {
  isSetting?: boolean,
  error?: any,
  currentLicense?: any,
  currentApplication?: any,
};

const initialState = {
  isSetting: false,
  error: null,
  currentLicense: null,
  currentApplication: null,
};

export const settingsReducer = (
  state: SettingsType = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.SET_CURRENT_LICENSE:
      return {
        ...state,
        currentLicense: action.payload,
        error: null
      }
    case actions.SET_CURRENT_APPLICATION:
      return {
        ...state,
        currentApplication: action.payload,
        error: null
      }
    default:
      return state
  }
};
